import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router';

const routes: Array<RouteRecordRaw> = [
  {
    path: '/',
    name: 'Home',
    component: () => import('../modules/pages/HomePage.vue'),
  },
  {
    path: '/:pathMatch(.*)*',
    name: 'ErrorView',
    component: () => import('../modules/pages/HomePage.vue'),
  }
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

export default router;
